import React, { useState, useEffect } from 'react';
import './_Footer.css';

type Props = {
  allRowsDataNumber?: number;
  AllRowsCounter: number;
  rowsInPage: number;
  currentPage: number;
  onNextPageClick: Function;
  onPrevPageClick: Function;
  onFirstPageClick: Function;
  onLastPageClick: Function;
};

const Footer: React.FC<Props> = ({
  allRowsDataNumber,
  AllRowsCounter,
  rowsInPage,
  currentPage: currentPageProp,
  onNextPageClick,
  onPrevPageClick,
  onFirstPageClick,
  onLastPageClick,
}) => {
  // State hooks
  const [currentPage, setCurrentPage] = useState(currentPageProp);
  const [rowsMin, setRowsMin] = useState(
    rowsInPage * (currentPageProp - 1) + 1
  );
  const [rowsMax, setRowsMax] = useState(rowsInPage * currentPageProp);
  const [rowsAll, setRowsAll] = useState(AllRowsCounter);
  const [hasNext, setHasNext] = useState<boolean>(true);
  const [hasPrev, setHasPrev] = useState<boolean>(false);

  // Effect hook to update paging data when props change
  useEffect(() => {
    setRowsMin(rowsInPage * (currentPage - 1) + 1);
    setRowsMax(rowsInPage * currentPage);
    setRowsAll(AllRowsCounter);
  }, [currentPage, rowsInPage, AllRowsCounter]);
  useEffect(() => {
    setNextPrevColors();
  }, [currentPage]);


const setNextPrevColors=()=>{
  if(currentPage>1){
    setHasPrev(true);
  }
  else{
    setHasPrev(false);
  }

  if(currentPage<rowsMax){
    setHasNext(true);
  }
  else{
    setHasNext(false);
  }
}

  const handleNextPageClick = () => {
    let newCurrentPage = currentPage;
    console.log('handleNextPageClick-rowsAll', rowsAll)
    if (rowsAll && rowsAll > currentPage) {
      newCurrentPage += 1;
      
    } else {
      newCurrentPage = rowsAll;
      
    }
    console.log('handleNextPageClick-newCurrentPage', newCurrentPage)
    setCurrentPage(newCurrentPage);
    onNextPageClick(newCurrentPage);

    
  };

  const handlePrevPageClick = () => {
    let newCurrentPage = currentPage;
    if (newCurrentPage > 1) {
      newCurrentPage -= 1;
      
    } else {
      newCurrentPage = 1;
      
    }
    setCurrentPage(newCurrentPage);
    onPrevPageClick(newCurrentPage);
    
  };

  const handleFirstPageClick = () => {
    setCurrentPage(1);
    onFirstPageClick(1);
    
  };

  const handleLastPageClick = () => {
    setCurrentPage(rowsAll);
    onLastPageClick(rowsAll);
    
  };

  const handleCurrentPageChanged = (evt: React.ChangeEvent<HTMLInputElement>) => {
    let newPage = parseInt(evt.currentTarget.value, 10);
    if (newPage < 1) newPage = 1;
    setCurrentPage(newPage);
    onNextPageClick(newPage);
    
  };

  return (
    <footer className="footer">
      <div className="page-navigation flex-centered flex-justify-center">
        <div className={hasNext?"left-navigation flex-centered flex-space-between":"left-navigation disabled flex-centered flex-space-between"}>
          <div className="icon arrow" onClick={handleNextPageClick}></div>
          <div className="icon forward" onClick={handleLastPageClick}></div>
        </div>
        <div className="page-info flex-centered flex-space-between">
          <span>עמוד</span>
          <div className="page-number">
            <input
              type="number"
              value={currentPage}
              onChange={handleCurrentPageChanged}
            />
          </div>
          <span>מתוך</span>
          <span>{rowsAll}</span>
        </div>
        <div className={hasPrev?"right-navigation flex-centered flex-space-between":"right-navigation disabled flex-centered flex-space-between"}>
          <div className="icon forward" onClick={handleFirstPageClick}></div>
          <div className="icon arrow" onClick={handlePrevPageClick}></div>
        </div>
      </div>
      <div className="page-counter-data flex-centered flex-justify-center">
        <div>
          <span>מציג</span>
          <span className="start-number">{rowsMin}</span>
          <span>עד</span>
          <span className="last-number">{rowsMax}</span>
          <span>מתוך</span>
          <span className="tottal-items">{allRowsDataNumber ? allRowsDataNumber : AllRowsCounter}</span>
        </div>
        <div className="icon refresh-counter"></div>
      </div>
    </footer>
  );
};

export default Footer;
